"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"

export default function NavigationHighlighter() {
  const pathname = usePathname()

  useEffect(() => {
    // Remove all existing active classes
    const allNavLinks = document.querySelectorAll("nav a")
    allNavLinks.forEach((link) => {
      link.classList.remove("border-b-2", "border-interest-blue", "bg-gray-50", "font-bold")
    })

    // Find and highlight active links
    allNavLinks.forEach((link) => {
      const href = link.getAttribute("href")
      if (!href) return

      const isActive = (href === "/" && pathname === "/") || (href !== "/" && pathname.startsWith(href))

      if (isActive) {
        // Check if it's a desktop nav link (in header nav)
        if (link.closest("header nav")) {
          // For main navigation items
          if (!link.closest(".group-hover\\:block")) {
            link.classList.add("border-b-2", "border-interest-blue")
          } else {
            // For dropdown items
            link.classList.add("bg-gray-50", "font-bold")
          }
        }
      }
    })

    // Also check for parent items that should be highlighted
    allNavLinks.forEach((link) => {
      const parentDiv = link.closest(".group")
      if (!parentDiv) return

      // Check if any child link is active
      const childLinks = parentDiv.querySelectorAll(".group-hover\\:block a")
      let hasActiveChild = false

      childLinks.forEach((childLink) => {
        const childHref = childLink.getAttribute("href")
        if (childHref && pathname.startsWith(childHref)) {
          hasActiveChild = true
        }
      })

      if (hasActiveChild) {
        const parentLink = parentDiv.querySelector(":scope > a")
        if (parentLink && parentLink.closest("header nav")) {
          parentLink.classList.add("border-b-2", "border-interest-blue")
        }
      }
    })
  }, [pathname])

  return null
}
